<template>
  <div>
    <div class="title-warp">
      <div class="title">智能问答评价</div>
      <el-switch
        class="select"
        v-model="value1"
        active-text="硬文"
        inactive-text="软文"
        @change="changetype();"
      >
      </el-switch>
    </div>
    <div class="type">
      <div style="margin:0 30px;padding:10px">
        一级标签<select name="筛选" v-model="state" @change="getstatus();">
          <option
            :value="item.value"
            v-for="(item, index) of onegener"
            :key="index"
            >{{ item.value }}</option
          >
        </select>
      </div>
      <div style="margin:0 30px;padding:10px">
        二级标签<select name="二级" v-model="erjiID" @change="ifhave = false;">
          <option :value="item.id" v-for="(item, index) of erji" :key="index">{{
            item.name + "," + item.content_type
          }}</option>
        </select>
      </div>
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="addValue(value1);"
        :disabled="ifhave"
        >增加{{ value1 ? "硬文" : "软文" }}</el-button
      >
      <el-button type="primary" @click="shaixuan();" :disabled="ifhave"
        >筛选</el-button
      >
    </div>
    <el-table :data="housetype">
      <el-table-column v-if="value1" label="硬文" prop="content">
      </el-table-column>
      <el-table-column v-else label="软文" prop="content"> </el-table-column>
      <el-table-column label="操作" prop="">
        <template slot-scope="scope">
          <div>
            <el-button @click="gethouse('删除', scope.row);">删除</el-button>
            <el-button @click="gethouse('修改', scope.row);"
              >修改{{ value1 ? "硬文" : "软文" }}</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="完成人与完成时间" prop="">
        <template slot-scope="scope">
          <div>
            初次完成人：{{ scope.row.name }}<br />
            初次时间：{{ scope.row.create_time }}<br />
            修改人员：{{ scope.row.update_name }}<br />
            修改时间：{{ scope.row.update_time }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="status" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item
          label="语句"
          v-if="status == '硬文' || status == '软文' || status == '修改'"
        >
          <textarea v-model="form.content" cols="50" rows="10"></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false;">取 消</el-button>
        <el-button type="primary" @click="upData();">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifhave: true,
      erjiID: "",
      erji: [],
      onegener: [
        {
          value: "总体评价",
          sign: "1",
          erji: []
        },
        {
          value: "客餐厅",
          erji: [],
          sign: "2"
        },
        {
          value: "阳台",
          erji: [],
          sign: "3"
        },
        {
          value: "厨房",
          erji: [],
          sign: "4"
        },
        {
          value: "主卧",
          erji: [],
          sign: "5"
        },
        {
          value: "次卧",
          erji: [],
          sign: "6"
        },
        {
          value: "书房",
          erji: [],
          sign: "7"
        },
        {
          value: "不利因素",
          erji: [],
          sign: "8"
        },
        { value: "配套总句", erji: [], sign: "9" },
        { value: "交通", erji: [], sign: "10" },
        { value: "商业", erji: [], sign: "11" },
        { value: "学校", erji: [], sign: "12" },
        { value: "医疗", erji: [], sign: "13" },
        { value: "景观", erji: [], sign: "14" },
        { value: "配套信息", erji: [], sign: "15" },
        { value: "规划总句", erji: [], sign: "16" },
        { value: "住宅占比", erji: [], sign: "17" },
        { value: "除住宅、其它的占比", erji: [], sign: "18" },
        { value: "超过一定值的占比", erji: [], sign: "19" },
        { value: "价值分数", erji: [], sign: "20" },
        { value: "热度分析", erji: [], sign: "21" },
        { value: "价格分析", erji: [], sign: "22" },
        { value: "企业分析", erji: [], sign: "23" },
        { value: "办公楼分析", erji: [], sign: "24" },
        { value: "配套分数", erji: [], sign: "25" },
        { value: "VR玄关", erji: [],sign: '26' },
        { value: "VR客餐厅", erji: [],sign: '27' },
        { value: "VR厨房", erji: [],sign: '28' },
        { value: "VR阳台", erji: [],sign: '29' },
        { value: "VR储物间", erji: [],sign: '30' },
        { value: "VR主卧", erji: [],sign: '31' },
        { value: "VR主卫", erji: [],sign: '32' },
        { value: "VR次卧", erji: [],sign: '33' },
        { value: "VR书房", erji: [],sign: '34' },
        { value: "VR客卫", erji: [],sign: '35' },
        { value: "VR露台", erji: [],sign: '36' },
        { value: "VR保姆间", erji: [],sign: '37' }
      ],
      state: "",
      condition: true,
      dialogFormVisible: false,
      form: {
        id: "",
        name: "",
        condition_id: "",
        content: ""
      },
      status: "",
      value1: true,
      housetype: [
        {
          four: ["1"],
          five: ["1"]
        }
      ]
    };
  },
  mounted() {
    let type = "";
    if (this.value1) {
      type = "硬文";
    } else {
      type = "软文";
    }
    this.getcondition();
  },
  methods: {
    upData() {
      if (this.value1) {
        this.form.type = "硬文";
      } else {
        this.form.type = "软文";
      }
      this.form.condition_id = this.erjiID;
      if (this.status == "硬文" || this.status == "软文") {
        this.$axios
          .post(this.$url_prefix + "auto/article/add", this.form)
          .then(res => {
            console.log(res);
            this.shaixuan();
            this.form.content = "";
            this.dialogFormVisible = false;
          });
      } else if (this.status == "修改") {
        this.$axios
          .post(this.$url_prefix + "auto/article/update", this.form)
          .then(res => {
            console.log(res);
            this.shaixuan();
            this.form.content = "";
            this.dialogFormVisible = false;
          });
      } else {
        this.$axios
          .get(this.$url_prefix + "auto/article/delete", {
            params: {
              id: this.form.id
            }
          })
          .then(res => {
            console.log(res);
            this.shaixuan();
            this.dialogFormVisible = false;
          });
      }
      // dialogFormVisible = false
    },
    getlist(type) {
      let condition_id = this.erjiID;
      this.$axios
        .get(this.$url_prefix + "condition/article/list", {
          params: {
            condition_id,
            type: type
          }
        })
        .then(res => {
          this.housetype = res.data.data;
        });
    },
    getcondition() {
      this.$axios.get(this.$url_prefix + "condition/list").then(res => {
        console.log(res.data.data);
        let erji = [];
        for (var item of res.data.data) {
          if (item.sign == "1") {
            this.onegener[0].erji.push(item);
          } else if (item.sign == "2") {
            this.onegener[1].erji.push(item);
          } else if (item.sign == "3") {
            this.onegener[2].erji.push(item);
          } else if (item.sign == "4") {
            this.onegener[3].erji.push(item);
          } else if (item.sign == "5") {
            this.onegener[4].erji.push(item);
          } else if (item.sign == "6") {
            this.onegener[5].erji.push(item);
          } else if (item.sign == "7") {
            this.onegener[6].erji.push(item);
          } else if (item.sign == "8") {
            this.onegener[7].erji.push(item);
          } else if (item.sign == "9") {
            this.onegener[8].erji.push(item);
          } else if (item.sign == "10") {
            this.onegener[9].erji.push(item);
          } else if (item.sign == "11") {
            this.onegener[10].erji.push(item);
          } else if (item.sign == "12") {
            this.onegener[11].erji.push(item);
          } else if (item.sign == "13") {
            this.onegener[12].erji.push(item);
          } else if (item.sign == "14") {
            this.onegener[13].erji.push(item);
          } else if (item.sign == "15") {
            this.onegener[14].erji.push(item);
          } else if (item.sign == "16") {
            this.onegener[15].erji.push(item);
          } else if (item.sign == "17") {
            this.onegener[16].erji.push(item);
          } else if (item.sign == "18") {
            this.onegener[17].erji.push(item);
          } else if (item.sign == "19") {
            this.onegener[18].erji.push(item);
          } else if (item.sign == "20") {
            this.onegener[19].erji.push(item);
          } else if (item.sign == "21") {
            this.onegener[20].erji.push(item);
          } else if (item.sign == "22") {
            this.onegener[21].erji.push(item);
          } else if (item.sign == "23") {
            this.onegener[22].erji.push(item);
          } else if (item.sign == "24") {
            this.onegener[23].erji.push(item);
          } else if (item.sign == "25") {
            this.onegener[24].erji.push(item);
          }else if (item.sign == "26") {
            this.onegener[25].erji.push(item);
          }else if (item.sign == "27") {
            this.onegener[26].erji.push(item);
          }else if (item.sign == "28") {
            this.onegener[27].erji.push(item);
          }else if (item.sign == "29") {
            this.onegener[28].erji.push(item);
          }else if (item.sign == "30") {
            this.onegener[29].erji.push(item);
          }else if (item.sign == "31") {
            this.onegener[30].erji.push(item);
          }else if (item.sign == "32") {
            this.onegener[31].erji.push(item);
          }else if (item.sign == "33") {
            this.onegener[32].erji.push(item);
          }else if (item.sign == "34") {
            this.onegener[33].erji.push(item);
          }else if (item.sign == "35") {
            this.onegener[34].erji.push(item);
          }else if (item.sign == "36") {
            this.onegener[35].erji.push(item);
          }else if (item.sign == "37") {
            this.onegener[36].erji.push(item);
          }
        }
        console.log(this.onegener);
      });
    },
    gethouse(status, row) {
      this.status = status;
      this.form.id = row.id;
      if (status == "修改") {
        this.form.content = row.content;
      }
      this.dialogFormVisible = true;
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    pushifo() {
      this.dialogFormVisible = false;
    },
    addValue(status) {
      status ? (this.status = "硬文") : (this.status = "软文");
      this.dialogFormVisible = true;
    },
    changetype() {
      let type = "";
      if (this.value1) {
        type = "硬文";
      } else {
        type = "软文";
      }
      this.getlist(type);
    },
    getstatus() {
      let con = this.onegener.filter(item => {
        return item.value == this.state;
      });
      this.erji = con[0].erji;
      console.log(con, this.erji);
    },
    shaixuan() {
      let condition_id = this.erjiID;
      let type = "";
      if (this.value1) {
        type = "硬文";
      } else {
        type = "软文";
      }
      this.$axios
        .get(this.$url_prefix + "condition/article/list", {
          params: {
            condition_id,
            type
          }
        })
        .then(res => {
          console.log(res);
          this.housetype = res.data.data;
        });
    }
  }
};
</script>

<style>
.title-warp {
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  border-bottom: 1px solid black;
}
.title-warp .select {
  margin-left: 50px;
}
.type {
  display: flex;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/HouseType.vue